module.exports = __webpack_public_path__ + "static/media/refresh-svgrepo-com.b1547aec.svg";